module.exports = __webpack_public_path__ + "img/Auto-select-shop-bumpertobumper.be812396.jpg";